/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiGreetingsOrderMutationRequest, PutApiGreetingsOrderMutationResponse, PutApiGreetingsOrder400, PutApiGreetingsOrder401, PutApiGreetingsOrder403, PutApiGreetingsOrder404, PutApiGreetingsOrder500 } from "../../types/PutApiGreetingsOrder.ts";
import { putApiGreetingsOrderMutationResponseSchema, putApiGreetingsOrderMutationRequestSchema } from "../../zod/GreetingsSchemas/putApiGreetingsOrderSchema.ts";

function getPutApiGreetingsOrderUrl() {
  const res = { method: 'PUT', url: `/api/greetings/order` as const }  
  return res
}

/**
 * @summary Изменение приоритетов шаблонов
 * {@link /api/greetings/order}
 */
export async function putApiGreetingsOrder({ data }: { data?: PutApiGreetingsOrderMutationRequest }, config: Partial<RequestConfig<PutApiGreetingsOrderMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiGreetingsOrderMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiGreetingsOrderMutationResponse, ResponseErrorConfig<PutApiGreetingsOrder400 | PutApiGreetingsOrder401 | PutApiGreetingsOrder403 | PutApiGreetingsOrder404 | PutApiGreetingsOrder500>, PutApiGreetingsOrderMutationRequest>({ method : "PUT", url : getPutApiGreetingsOrderUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiGreetingsOrderMutationResponseSchema.parse(res.data)
}